import { useState, useEffect } from "react";
import { getAuth } from "firebase/auth";

const EditarPerfil = ({ userData, onCancel, onSave }) => {
  const [editedData, setEditedData] = useState(userData);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (user) {
      setCurrentUser(user);
    }
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setEditedData({ ...editedData, [name]: value });
  };

  const handleSave = async (e) => {
    e.preventDefault();
    try {
      await onSave(editedData);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="space-y-6">
      {currentUser && (
        <img
          className="w-32 h-32 object-cover rounded-full shadow-xl mx-auto"
          src={currentUser.photoURL}
          alt="Profile"
        />
      )}
      <form className="space-y-6 mx-auto" onSubmit={handleSave}>
        <div className="grid grid-cols-1 gap-4">
          {[
            {
              label: "Correo electrónico",
              name: "email",
              value: editedData?.email,
              disabled: true,
            },
            {
              label: "Nombre de usuario",
              name: "username",
              value: editedData.username || "",
              disabled: false,
            },
            {
              label: "Número de teléfono",
              name: "phoneNumber",
              value: editedData.phoneNumber || "",
              disabled: false,
            },
          ].map((field, idx) => (
            <div
              key={idx}
              className="flex flex-col items-center justify-center"
            >
              <span className="text-xs font-main text-gray-600">
                {field.label}
              </span>
              <input
                type="text"
                name={field.name}
                value={field.value}
                onChange={handleChange}
                disabled={field.disabled}
                className="font-main text-sm  h-full w-1/2 p-2 pl-4 pr-8 appearance-none bg-white border-2 border-gray-200 rounded-lg hover:border-gray-400 focus:ring-1 focus:ring-[#504527] transition-all duration-200 shadow-sm disabled:bg-gray-100 disabled:text-gray-300"
              />
            </div>
          ))}
        </div>

        <div className="flex justify-evenly mt-4">
          <button
            type="submit"
            className="font-main  px-4 py-2 w-[10rem] bg-secondary text-white rounded hover:bg-orange-700 transition"
          >
            Guardar
          </button>
          <button
            type="button"
            onClick={onCancel}
            className="font-main  px-4 py-2 w-[10rem] bg-red-600 text-white rounded hover:bg-red-700 transition"
          >
            Cancelar
          </button>
        </div>
      </form>
    </div>
  );
};

export default EditarPerfil;
